$().ready(function(){

	$( "#paxDialog" ).dialog({
		autoOpen: false,
		show: "fade",
		hide: "fade",
		modal: true,
		buttons: {
			Ok: function() {
				$( this ).dialog( "close" );
				showSPO($("#mybeatifulHidden").val());
			}
		}
	});

	$("#showFilter").click(function() {
		$('.resultLeft').fadeToggle("fast");
		$(this).toggleClass("openFilter");
		return false;
	});
	$(".pop-btn-ok").click(function() {
		$('.resultLeft,.pop-sorting').hide();
		return false;
	});

    $(".btn-sort").click(function() {
        $('.pop-sorting').fadeToggle("fast");
        $(this).toggleClass("openFilter");
        return false;
    });
    
    $('[name=sortingSearch]').click(function () {

        CharterFilter.sortBy = $(this)[0].id;
         getPageResult();
         $('.resultLeft,.pop-sorting').hide();
        return false;
    });

    $( "#searchSorting" ).buttonset();

    var conditionalSelect = $("#arrCityName");
    var arrAirOptions = conditionalSelect.children(".arrAirOpt").clone();

	$("#depCityName").change(function() {
		if(this.options != 'undefined' && this.selectedIndex != 'undefined' && this.options[this.selectedIndex] != 'undefined'){
			var selectedText = this.options[this.selectedIndex].text;
			$(this).parent().find('.field-value-select').text(selectedText);
			
			conditionalSelect.children(".arrAirOpt").remove();
			
			var filteredAirports;
			var selectedValue = this.options[this.selectedIndex].value;
			if(selectedValue != ""){
				$('[name=selDepAirport]').val(selectedValue);
				
				filteredAirports = arrAirOptions.clone().filter("."+selectedValue);
				$("#arrCityName").val('');				
				$("#arrCityName").change();
			}else{
				$('[name=selDepAirport]').val("");
				
				filteredAirports = arrAirOptions.clone();
			}
			
			var countryCode = '';
			filteredAirports.each(function(){
				if ($(this).attr("countryCode") != undefined){
					if (countryCode != $(this).attr("countryCode")) {
						countryCode = $(this).attr("countryCode");
						var countryOption = arrAirOptions.clone().filter(".arrAirOpt."+countryCode);
						conditionalSelect.append(countryOption);
					}
					conditionalSelect.append($(this));
				}
			});			
		}
	}).change();
	
	$("#arrCityName").change(function() {
		if(this.selectedIndex > -1){
			var selectedValue = this.options[this.selectedIndex].text;
			$(this).parent().find('.field-value-select').text(selectedValue);
			
			var selectedValue = this.options[this.selectedIndex].value;
			if(selectedValue != ""){
				$('[name=selArrAirport]').val(selectedValue);
			}else{
				$('[name=selArrAirport]').val("");
			}
		} else {
			$('[name=selArrAirport]').val("");
		}
	}).change();	
	
	$("#charterDateRange").change(function() {
		if(this.selectedIndex > -1){
			var selectedValues = this.options[this.selectedIndex].value.split("-");
			var month = selectedValues[0];
			var year = (parseInt(selectedValues[1])+parseInt("1900")).toString();
			var yearControl = selectedValues[1];
			var selectedText = this.options[this.selectedIndex].text;
			$(this).parent().find('.field-value-select').text(selectedText);
			if(selectedValues != ""){
				$('[name=selDateMonth]').val(month);
				$('[name=selDateYear]').val(year);
				$('[name=selDateYearControl]').val(yearControl);
			}else{
				$('[name=selDateMonth]').val("");
				$('[name=selDateYear]').val("");
				$('[name=selDateYear]').val("");
			}
		} else {
			$('[name=selDateMonth]').val("");
			$('[name=selDateYear]').val("");
			$('[name=selDateYear]').val("");
		}
	}).change();	
	
});

function  showPaxDialog (index){
	 $("#mybeatifulHidden").val(index);
	 $("#paxDialog").dialog("open");
	 return false;
}

function showSPO(index) {
	var numAdult = $("#spaxADT").val();
	var numChild = $("#spaxCHD").val();
	var numInfant = $("#spaxINF").val();
	
	
	$('input[name=paxADT]').val(numAdult);
	$('input[name=paxCHD]').val(numChild);
	$('input[name=paxINF]').val(numInfant);
	
	openLoaderBox();
	document.getElementById("spoPostFrm_" + index).submit();
}


